<p class="notification-message"
  [id]="messageId"
  [class.notification-message--expanded]="expanded"
  [class.notification-message--clamp-2]="!expanded && maxLines === 2"
  [class.notification-message--clamp-3]="!expanded && maxLines === 3"
  [class.notification-message--clamp-4]="!expanded && maxLines === 4">
  {{ body }}
</p>
<button type="button" class="notification-message__toggle btn btn-link btn-sm p-0"
  *ngIf="showToggle"
  (click)="toggleExpanded($event)"
  [attr.aria-expanded]="expanded"
  [attr.aria-controls]="messageId">
  {{ expanded ? 'Read less' : 'Read more' }}
</button>
